const MaximiseIcon = () => {
    // return <img src={chatbotIcon} alt="GenInsight.ai" style={{ height: height, width: width, fill: '#0093FB' }}/>
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.80002 2.3999H4.53336C3.35515 2.3999 2.40002 3.35503 2.40002 4.53324V8.7999M8.80002 21.5999H4.53336C3.35515 21.5999 2.40002 20.6448 2.40002 19.4666V15.1999M15.2 2.3999H19.4667C20.6449 2.3999 21.6 3.35503 21.6 4.53324V8.7999M21.6 15.1999V19.4666C21.6 20.6448 20.6449 21.5999 19.4667 21.5999H15.2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    
}

export default MaximiseIcon;